module.exports = __webpack_public_path__ + "img/worli-matka.64d5aef.jpg";